import React from 'react'
import PropTypes from 'prop-types'

import CircularProgress from 'material-ui/CircularProgress'
import Utils from 'billing/infra/Utils'

const BillItemsHeader = () => {
  return (
    <div style={styles.headerRow}>
      <div style={styles.itemColumn(true, 250)}>ITEMS</div>
      <div style={styles.itemColumn(true, null, 'center')}>QUANTITY</div>
      <div style={styles.itemColumn(true, null, 'center')}>RATE</div>
      <div style={styles.itemColumn(true, null, 'center')}>TAX %</div>
      <div style={styles.itemColumn(true, null, 'right')}>AMOUNT</div>
    </div>
  )
}

const BillItem = ({ item }) => {
  const amount = Utils.getItemAmount(item).toFixed(2)
  return (
    <div style={styles.itemContainer}>
      <div style={styles.itemRow}>
        <div style={styles.itemColumn(false, 250)}>
          { item.name }
        </div>
        <div style={styles.itemColumn(false, null, 'center')}>
          { item.quantity }
        </div>
        <div style={styles.itemColumn(false, null, 'center')}>
          ${ item.rate }
        </div>
        <div style={styles.itemColumn(false, null, 'center')}>
          { item.taxPercent || 0 }%
        </div>
        <div style={styles.itemColumn(false, null, 'right')}>${ amount }</div>
      </div>
      { item.description &&
        <div style={styles.description}>
          { item.description }
        </div>
      }
    </div>
  )
}

BillItem.propTypes = {
  item: PropTypes.object.isRequired
}

export default class BillItemsPreview extends React.Component {

  static propTypes = {
    billEditor: PropTypes.object.isRequired,
    hasPayments: PropTypes.bool
  }
  
  render() {
    const loading = this.props.billEditor.isLoadingItems()
    const items = this.props.billEditor.getItems() || []
    let total = 0, subtotal = 0, tax = 0
    let content
    if (loading) {
      content = <div style={styles.progress}>
        <CircularProgress thickness={2} />
      </div>
    }
    else
    if (items.length === 0) {
      content = <div style={styles.zeroItems}>No items have been added yet.</div>
    }
    else {
      content = items.map((item, index) =>
        <BillItem key={index}
          item={item}
          onItemDeleteRequested={this.handleItemDeleteRequested}
          onItemNameChanged={this.handleItemNameChanged}
          onItemDescriptionChanged={this.handleItemDescriptionChanged}
          onItemQuantityChanged={this.handleItemQuantityChanged}
          onItemRateChanged={this.handleItemRateChanged} />)
      subtotal = items.filter(item => item.rate).reduce((sum, item) => sum + Utils.getItemNet(item), 0)
      total = items.filter(item => item.rate).reduce((sum, item) => sum + Utils.getItemAmount(item), 0)
      tax = total - subtotal
    }
    return (
      <div style={styles.container}>
        <BillItemsHeader />
        { content }
        { !loading &&
          <div style={styles.summaryContent}>
            <div style={styles.summaryRows}>
              <div style={styles.summaryRow()}>
                <div style={styles.summaryLabel()}>SUBTOTAL</div>
                <div style={styles.summaryPrice()}>${ subtotal.toFixed(2) }</div>
              </div>
              <div style={styles.summaryRow()}>
                <div style={styles.summaryLabel()}>TAX</div>
                <div style={styles.summaryPrice()}>${ tax.toFixed(2) }</div>
              </div>
              <div style={styles.summaryRow(!this.props.hasPayments)}>
                <div style={styles.summaryLabel(true)}>TOTAL</div>
                <div style={styles.summaryPrice(true)}>${ total.toFixed(2) }</div>
              </div>
              { this.props.hasPayments &&
                <div style={styles.amountDueRow}>
                  <div style={styles.amountDueLabel}>AMOUNT DUE</div>
                  <div style={styles.amountDuePrice}>${ Utils.getBillAmountDue(this.props.billEditor.getBillingEntity()).toFixed(2) }</div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 32,
    paddingRight: 32,
    paddingTop: 48,
    paddingBottom: 48
  },
  headerRow: {
    display:'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: 'solid 1px #e7e8ec',
    paddingTop: 8,
    paddingBottom: 8
  },
  description: {
    fontSize: 14,
    marginTop: 8,
    color: '#828691'
  },
  itemColumn: (header, width, textAlign) => ({
    color: header ? '#9da8bb' : '#4a4a4a',
    textAlign: textAlign || 'left',
    fontSize: 12,
    width: width || 64
  }),
  itemContainer: {
    display:'flex',
    flexDirection: 'column',
    borderBottom: 'solid 1px #e7e8ec',
    paddingTop: 12,
    paddingBottom: 12
  },
  itemRow: {
    display:'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  summaryContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    fontSize: 12
  },
  summaryRows: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%'
  },
  summaryRow: last => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: last ? 'none' : '1px solid rgb(231, 232, 236)',
    paddingTop: 12,
    paddingBottom: 12
  }),
  amountDueRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: 12
  },
  summaryLabel: main => ({
    color: main ? '#1f2229' : '#9da8bb'
  }),
  summaryPrice: main => ({
    color: main ? '#1f2229' : '#4a4a4a'
  }),
  amountDueLabel: {
    color: '#1f2229'
  },
  amountDuePrice: {
    color: '#1f2229'
  },
  progress: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: 22
  },
  zeroItems: {
    textAlign: 'center',
    borderBottom: 'solid 1px #e7e8ec',
    fontSize: 14,
    paddingTop: 12,
    paddingBottom: 12
  }
}



// WEBPACK FOOTER //
// ./src/billing/common/modules/items/BillItemsPreview.js